var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',{staticClass:"container"},[_c('iframe',{attrs:{"src":_vm.urlInsylay,"width":"100%","height":"920","frameborder":"0"}})])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }